import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface AirPickupRequest {
    limit: string;
    page: number;
    from_date: string;
    to_date: string;
}
export type DataListProps = {
    list_no: number;
    w_date: string;
    accept_no: number;
    f_gubun: string;
    f_company: string;
    f_name: string;
    f_tel: string;
    f_address1: string;
    f_address2: string;
    t_city: string;
    f_time: string;
    result: number;
    result_text: string;
};

export interface PickupResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleAirPickup = (data: AirPickupRequest | null): UseQueryResult<PickupResponseData, Error> => {
    let url = enum_api_uri.get_console_air_pickup;
    return useQuery({
        queryKey: ["useGetConsoleAirPickup", data],
        queryFn: async () => {
            if (!data) throw new Error("Invalid request data");
            const response = await axiosInstance.get(url, {
                params: {
                    page: data.page,
                    limit: data.limit,
                    from_date: data.from_date,
                    to_date: data.to_date,
                },
            });
            return response.data.data;
        },
        enabled: !!data,
    });
};
